import {clickEvent} from "../../../../webpack/modules/events";
import {showImageZoomPopup} from "../../../../webpack/modules-optimized/popup-image-zoom";

clickEvent('#cart .cart-item .images-zoom-popup', true, function(element) {
    let productId = element.closest('.product-scope').dataset.productId;

    showImageZoomPopup(productId, 0);
});